<template>
  <div class='slider-full'>
    <v-container>
      <v-row>
        <v-col cols='12'>
          <Slider :full='true' />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import Slider from '@/components/elements/other/Slider.vue';

export default {
  name: 'SliderFull',
  components: {
    Slider
  }
};
</script>

<style scoped lang='scss'>
.slider-full {
  margin-bottom: 20px;
}
</style>
